import { GenufitAuthBrandStack } from './GenufitAuthBrandStack'
import { GenufitFitMark } from './GenufitFitMark'

type GenufitAuthBrandProps = {
  className?: string
  showWordmark?: boolean
}

/** Auth lockup: Round 11 mirrored mark + Direction C wordmark (HIR-198 v5). */
export function GenufitAuthBrand({ className, showWordmark = true }: GenufitAuthBrandProps) {
  return (
    <div className={className} data-testid="genufit-wordmark" role="img" aria-label="GenuFit">
      <GenufitAuthBrandStack
        mark={<GenufitFitMark size={72} className="size-16 sm:size-[72px]" />}
        showWordmark={showWordmark}
      />
    </div>
  )
}
